

















import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import * as routes from "@/employee/route-names";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    GenericLoadingSpinner,
    SettingsNavigation,
    SettingsHeader
  }
})
export default class Settings extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  hsabAccountsStore = useHsabAccountsStore();

  routes = routes;

  @Watch("custodianSettingsStore.isLoaded")
  custodianSettingsLoaded (newVal, oldVal) {
    if (newVal === true) {
      if (this.custodianSettingsStore.isHsaBankCustodian) {
        this.hsabAccountsStore.getHsabAccounts();
      } else {
        this.navigate();
      }
    }
  }

  @Watch("hsabAccountsStore.allHsabAccountsLoaded")
  isHsaBankCustodianChanged (newVal, oldVal) {
    if (newVal === true) {
      this.navigate();
    }
  }

  mounted () {
    if (!this.custodianSettingsStore.isLoaded) {
      this.custodianSettingsStore.getCustodianSettings();
    } else {
      if (this.custodianSettingsStore.isHsaBankCustodian) {
        if (this.hsabAccountsStore.allHsabAccountsLoaded) {
          this.navigate();
        } else {
          this.hsabAccountsStore.getHsabAccounts();
        }
      } else {
        this.navigate();
      }
    }
  }

  navigate () {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      if (this.hsabAccountsStore.userHasHsaAccount) {
        this.navigateToLinkedAccounts();
      } else {
        this.navigateToMyProfile();
      }
    } else {
      this.navigateToLinkedAccounts();
    }
  }

  navigateToLinkedAccounts () {
    this.$router.push({ name: routes.LinkedAccountsSettings });
  }

  navigateToMyProfile () {
    this.$router.push({ name: routes.MyProfileDisplay });
  }
}
